export default "__VITE_ASSET__DDaeejQX__"